var map = {
	"./PragmaticaSlabLight/PragmaticaSlabLight": 348,
	"./PragmaticaSlabLight/PragmaticaSlabLight.eot": 679,
	"./PragmaticaSlabLight/PragmaticaSlabLight.otf": 680,
	"./PragmaticaSlabLight/PragmaticaSlabLight.svg": 348,
	"./PragmaticaSlabLight/PragmaticaSlabLight.ttf": 681,
	"./PragmaticaSlabLight/PragmaticaSlabLight.woff": 682,
	"./QanelasBold/QanelasBold": 349,
	"./QanelasBold/QanelasBold.eot": 683,
	"./QanelasBold/QanelasBold.otf": 684,
	"./QanelasBold/QanelasBold.svg": 349,
	"./QanelasBold/QanelasBold.ttf": 685,
	"./QanelasBold/QanelasBold.woff": 686,
	"./QanelasLight/QanelasLight": 350,
	"./QanelasLight/QanelasLight.eot": 687,
	"./QanelasLight/QanelasLight.svg": 350,
	"./QanelasLight/QanelasLight.ttf": 688,
	"./QanelasLight/QanelasLight.woff": 689,
	"./QanelasLight/QanelasLight.woff2": 690,
	"./QanelasMedium/QanelasMedium": 351,
	"./QanelasMedium/QanelasMedium.eot": 691,
	"./QanelasMedium/QanelasMedium.svg": 351,
	"./QanelasMedium/QanelasMedium.ttf": 692,
	"./QanelasMedium/QanelasMedium.woff": 693,
	"./QanelasMedium/QanelasMedium.woff2": 694,
	"./QanelasRegular/QanelasRegular": 352,
	"./QanelasRegular/QanelasRegular.eot": 695,
	"./QanelasRegular/QanelasRegular.svg": 352,
	"./QanelasRegular/QanelasRegular.ttf": 696,
	"./QanelasRegular/QanelasRegular.woff": 697,
	"./QanelasSemiBold/QanelasSemiBold": 353,
	"./QanelasSemiBold/QanelasSemiBold.eot": 698,
	"./QanelasSemiBold/QanelasSemiBold.svg": 353,
	"./QanelasSemiBold/QanelasSemiBold.ttf": 699,
	"./QanelasSemiBold/QanelasSemiBold.woff": 700,
	"./QanelasThin/QanelasThin": 354,
	"./QanelasThin/QanelasThin.eot": 701,
	"./QanelasThin/QanelasThin.otf": 702,
	"./QanelasThin/QanelasThin.svg": 354,
	"./QanelasThin/QanelasThin.ttf": 703,
	"./QanelasThin/QanelasThin.woff": 704
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 678;